<template>
  <el-dialog
    title="应交款详情记录"
    :visible.sync="dialogVisible"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="head-title" style="padding-bottom: 10px">
      采集任务应收款式<span>{{ priceShow }}</span
      >元
    </div>
    <el-table
      border
      :data="dataList"
      style="width: 100%"
      height="400"
      :loading="pageTableLoading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <template #empty>
        <p>{{ pageTableLoading == true ? "数据加载中" : "暂无数据" }}</p>
      </template>
      <el-table-column
        align="center"
        label="工行全款支付人数"
        width="160"
        prop="onLinePayNoDeductionCount"
      >
        <template slot-scope="scope">
          {{ scope.row.onLinePayNoDeductionCount || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="工行全款支付金额"
        width="140"
        prop="onLinePayNoDeductionShotPrice"
      >
        <template slot-scope="scope">
          {{
            scope.row.onLinePayNoDeductionShotPrice
              ? Number(scope.row.onLinePayNoDeductionShotPrice).toFixed(2) +
                "元"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="I豆抵扣支付人数"
        width="140"
        prop="onLinePayHasDeductionCount"
      >
        <template slot-scope="scope">
          {{ scope.row.onLinePayHasDeductionCount || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="抵扣I豆数"
        width="110"
        prop="onLinePayHasDeductionIDouNum"
      >
        <template slot-scope="scope">
          {{ scope.row.onLinePayHasDeductionIDouNum || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="I豆抵扣后支付金额"
        width="160"
        prop="onLinePayHasDeductionRealPrice"
      >
        <template slot-scope="scope">
          {{
            scope.row.onLinePayHasDeductionRealPrice
              ? Number(scope.row.onLinePayHasDeductionRealPrice).toFixed(2) +
                "元"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="多余I豆数"
        width="110"
        prop="remainIDou"
      >
        <template slot-scope="scope">
          {{ scope.row.remainIDou || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="微信支付人数"
        width="120"
        prop="wxLinePayCount"
      >
        <template slot-scope="scope">
          {{ scope.row.wxLinePayCount || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="微信支付金额"
        width="120"
        prop="wxLinePayShotPrice"
      >
        <template slot-scope="scope">
          {{
            scope.row.wxLinePayShotPrice
              ? Number(scope.row.wxLinePayShotPrice).toFixed(2) + "元"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="线下支付人数"
        width="120"
        prop="offlinePayCount"
      >
        <template slot-scope="scope">
          {{ scope.row.offlinePayCount || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="线下支付金额"
        width="120"
        prop="offlinePayShotPrice"
      >
        <template slot-scope="scope">
          {{
            scope.row.offlinePayShotPrice
              ? Number(scope.row.offlinePayShotPrice).toFixed(2) + "元"
              : "-"
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="支付到账金额" width="120" prop="totalPayPrice">
                <template slot-scope="scope">
                    {{ scope.row.totalPayPrice || '-' }}
                </template>
            </el-table-column> -->
    </el-table>
  </el-dialog>
</template>
<script>
import { refundDetails } from "@/api/batch";
export default {
  name: "alertAccountsPayable",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      obj: {},
      pageTableLoading: true,
      dataList: [],
      priceShow: "0.00",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("updateVisible", val);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("updateVisible", false);
    },
    async initData(record) {
      this.pageTableLoading = true;
      const res = await refundDetails({
        id: record.id,
        collectType: record.collectType,
      });
      this.pageTableLoading = false;
      this.dataList =
        res.data && res.data.offlinePayCount >= 0 ? [res.data] : [];
      this.priceShow = record.accountsPayable || "0.00";
    },
  },
};
</script>
